// Module
var code = "<app-component></app-component>\n<div ui-view></div>\n";
// Exports
module.exports = code;